import { render, staticRenderFns } from "./PermissionsSettings.vue?vue&type=template&id=3b386543&"
import script from "./PermissionsSettings.vue?vue&type=script&lang=js&"
export * from "./PermissionsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports